import { render, staticRenderFns } from "./input-check-radio.vue?vue&type=template&id=0dbc8008&"
import script from "./input-check-radio.vue?vue&type=script&lang=js&"
export * from "./input-check-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports